var _defs, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAzure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "azure-original-wordmark-a",
    x1: 60.919,
    y1: 9.602,
    x2: 18.667,
    y2: 134.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "azure-original-wordmark-b",
    x1: 74.117,
    y1: 67.772,
    x2: 64.344,
    y2: 71.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "azure-original-wordmark-c",
    x1: 68.742,
    y1: 5.961,
    x2: 115.122,
    y2: 129.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892DF"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.717 76.293c-2.73-.175-4.317-1.728-4.737-4.633-.112-.773-.112-.793-.124-5.81l-.011-4.856h2.416l.009 4.697c.009 4.233.014 4.73.055 5.027.164 1.209.491 2.022 1.049 2.605.446.467.968.74 1.691.885.34.069 1.311.069 1.622 0a3.587 3.587 0 001.838-.996c.591-.59 1.028-1.427 1.24-2.373l.07-.319.008-4.736.008-4.738h2.467V75.94h-2.441v-1.182c0-.802-.009-1.178-.028-1.172a.975.975 0 00-.139.213 4.959 4.959 0 01-1.889 1.889c-.92.505-1.843.685-3.104.605zm27.7-.012a6.409 6.409 0 01-2.807-.916c-1.748-1.08-2.782-2.86-3.084-5.308-.105-.848-.118-1.986-.03-2.706.195-1.61.828-3.19 1.73-4.317.23-.29.755-.813 1.044-1.044a6.512 6.512 0 012.666-1.271c.566-.123 1.562-.181 2.163-.126 1.51.14 2.892.85 3.832 1.967.956 1.135 1.48 2.721 1.548 4.674a26.028 26.028 0 01.005 1.193l-.013.636-5.286.006-5.286.007v.236c0 .717.174 1.534.476 2.23.26.599.709 1.253 1.075 1.57a4.73 4.73 0 002.68 1.132c.374.035 1.326-.002 1.751-.067 1.215-.187 2.37-.663 3.301-1.36.11-.083.215-.16.234-.171.027-.017.034.197.033 1.1v1.12l-.251.155a8.757 8.757 0 01-3.542 1.226c-.382.047-1.783.068-2.24.034zm4.6-9.455c0-1.201-.507-2.536-1.224-3.223a3.366 3.366 0 00-1.867-.904c-.348-.054-1.081-.033-1.448.04a3.787 3.787 0 00-1.977 1.05 5.382 5.382 0 00-1.309 2.092c-.1.29-.216.765-.253 1.029l-.017.126h8.095v-.21zm-71.705 9.08l3.989-10.467 3.978-10.434h2.556l.106.27c.324.831 7.963 20.642 7.963 20.652 0 .007-.612.012-1.36.012h-1.36l-1.1-2.928-1.102-2.928h-8.866l-.038.1c-.021.054-.492 1.372-1.046 2.927l-1.006 2.829h-1.363c-1.078 0-1.36-.006-1.351-.033zm12.861-8.057c0-.005-.74-2.011-1.646-4.46-1.694-4.578-1.789-4.854-1.923-5.589-.063-.344-.095-.354-.132-.04a7.306 7.306 0 01-.23 1.007c-.045.139-.808 2.23-1.696 4.648a732.32 732.32 0 00-1.615 4.42c0 .012 1.63.022 3.621.022 1.992 0 3.621-.004 3.621-.008zm6.553 7.71v-.382l4.417-6.065 4.417-6.065-4-.013-3.998-.013-.007-1.014-.007-1.013h11.568v.684l-4.417 6.098c-2.43 3.354-4.418 6.104-4.418 6.11 0 .007 1.964.013 4.364.013h4.365v2.04H70.726zm32.411.363c-.01-.01-.017-3.373-.017-7.473v-7.456h2.414v1.537c0 .846.01 1.537.022 1.537.013 0 .072-.138.131-.307a5.31 5.31 0 011.349-2.075 3.499 3.499 0 011.907-.947c.207-.033.382-.04.796-.029.52.014.791.052 1.107.155l.1.032V63.4l-.285-.142a3.04 3.04 0 00-1.599-.32c-.389.02-.644.07-.955.186a3.021 3.021 0 00-1.521 1.241 7.206 7.206 0 00-1.01 2.9c-.02.177-.031 1.622-.036 4.469l-.007 4.207h-1.189c-.654 0-1.197-.008-1.207-.018z",
    fill: "#0089d6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.09.002h40.685L44.541 125.137a6.485 6.485 0 01-6.146 4.413H6.733a6.482 6.482 0 01-5.262-2.699 6.474 6.474 0 01-.876-5.848L39.944 4.414A6.488 6.488 0 0146.09 0z",
    fill: "url(#azure-original-wordmark-a)",
    transform: "translate(2.435 44.576) scale(.29986)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.983 69.745H14.638a.895.895 0 00-.612 1.55l12.431 11.603a1.955 1.955 0 001.334.525h10.954z",
    fill: "#0078d4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.09.002A6.434 6.434 0 0039.93 4.5L.644 120.897a6.469 6.469 0 006.106 8.653h32.48a6.941 6.941 0 005.328-4.531l7.834-23.089 27.985 26.101a6.618 6.618 0 004.165 1.519h36.396l-15.963-45.616-46.533.011L86.922.002z",
    fill: "url(#azure-original-wordmark-b)",
    transform: "translate(2.435 44.576) scale(.29986)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M98.055 4.408A6.476 6.476 0 0091.917.002H46.575a6.478 6.478 0 016.137 4.406l39.35 116.594a6.476 6.476 0 01-6.137 8.55h45.344a6.48 6.48 0 006.136-8.55z",
    fill: "url(#azure-original-wordmark-c)",
    transform: "translate(2.435 44.576) scale(.29986)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzure);
export default __webpack_public_path__ + "static/media/azure.210ecd057aff82fab2f291582b7eeb6f.svg";
export { ForwardRef as ReactComponent };